import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['admin', 'empty', 'error', 'unauthorized', 'loading']);
const allowedFixturePaths = new Set(['/settings/users']);

export type UserManagementVisualFixtureState = 'admin' | 'empty' | 'error' | 'unauthorized' | 'loading';

export function readUserManagementVisualFixture(href: string): UserManagementVisualFixtureState | null {
    const url = new URL(href);
    const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
    const fixtureState = url.searchParams.get('userManagementVisualFixture') || '';

    if (!isLocalHost || !allowedFixturePaths.has(url.pathname) || !allowedFixtureStates.has(fixtureState)) {
        return null;
    }

    return fixtureState as UserManagementVisualFixtureState;
}

export function isUserManagementVisualFixtureUrl(href: string): boolean {
    return readUserManagementVisualFixture(href) !== null;
}

export const userManagementVisualFixtureCanMatch: CanMatchFn = () => {
    if (typeof window === 'undefined' || !window.location) return false;

    return isUserManagementVisualFixtureUrl(window.location.href);
};
